import Typography from "antd/lib/typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useActiveClassroom } from "@sol/classrooms";
import { IUserResource } from "@sol/sdk";
import { Button } from "@sol/uikit/general/Button/Button";

import { UserPicker } from "@/entities/user";

type Props = {
    className?: string;
    learners?: IUserResource[];
    onSubmit: (learners: IUserResource[]) => void;
    onCancel: () => void;
    isSubmitting: boolean;
    onImportClick: () => void;
    apiErrorsReset?: () => void;
    apiErrors?: any;
};

export const LearnerPicker = ({
    className,
    learners = [],
    onSubmit,
    onCancel,
    isSubmitting,
    onImportClick,
    apiErrorsReset,
    apiErrors,
}: Props) => {
    const [t] = useTranslation();
    const { isLoading: isClassroomLoading } = useActiveClassroom();
    const [classroomLearners, setClassroomLearners] = useState<IUserResource[]>(learners);

    useEffect(() => {
        setClassroomLearners(learners);
    }, [learners]);

    return (
        <UserPicker
            className={className}
            title={t("form.LearnerForm.title")}
            subtitle={
                <>
                    <Typography.Text className="text-ant-lg">{t("form.LearnerForm.importHelper")}</Typography.Text>
                    <Button onClick={onImportClick} htmlType="button" className="mb-6 inline-flex w-fit" type="primary">
                        {t("form.LearnerForm.importLabel")}
                    </Button>
                </>
            }
            onUserAdd={learnerToAdd => setClassroomLearners([...classroomLearners, learnerToAdd])}
            users={classroomLearners}
            usersListTitle={t("form.addLearners.title")}
            noUserMessage={t("form.addLearners.learners.noLearner")}
            onUserRemove={email => setClassroomLearners(classroomLearners?.filter(learner => learner.email !== email))}
            isLoading={isClassroomLoading}
            onClose={onCancel}
            onSubmit={() => onSubmit(classroomLearners)}
            isSubmitting={isSubmitting}
            apiErrorsReset={apiErrorsReset}
            apiErrors={apiErrors}
        />
    );
};
